'use strict';

bbw.service.ScrollBottomHandler = Class({
    
    hasMore: function() {
        return false;
    },
    
    isLoading: function() {
        return false;
    },
    
    canMore: function() {
        return true;
    },
    
    loadMore: function() {
        Class.abstractMethod();
    }
    
});